import req from '../../api/request'

/** Filters for a schedule's leaderboard; absent fields are left off. */
export interface LeaderboardQuery {
  divisionId?: string
  conferenceId?: string
  global?: boolean
  goalie?: boolean
}

/**
 * GET /schedules/:scheduleId/stats/leaderboard — the raw response.
 * `useLeaderboard` owns the mapping into leaderboard categories.
 */
export const getScheduleLeaderboard = async (
  scheduleId: string,
  { divisionId, conferenceId, global, goalie }: LeaderboardQuery,
  signal?: AbortSignal
): Promise<unknown> =>
  req(`/schedules/${scheduleId}/stats/leaderboard`, {
    query: {
      ...(divisionId && { division_id: divisionId }),
      ...(conferenceId && { conference_id: conferenceId }),
      ...(global && { global: 1 }),
      ...(goalie !== undefined && { goalie: goalie ? 1 : 0 }),
    },
    signal,
  })
